<template>
  <div class="conditioning-suggestions suggest-bg" v-if="suggestions">
    <div class="page-header-center">
      <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/原理说明.png" alt="调理建议" class="page-header-icon" />
      <span class="page-header-title">调理建议</span>
    </div>
    <!-- 顶部横向滚动按钮区 (复用评估报告逻辑) -->
    <div class="suggest-tabs" ref="suggestTabsContainer">
      <div 
        class="suggest-tab-item" 
        v-for="tab in suggestTabs" 
        :key="tab.id"
        :ref="`tab-${tab.id}`"
        :class="{ active: activeSubTab === tab.id }"
        @click="scrollToTab(tab.id)"
      >
        {{ tab.title }}
      </div>
    </div>

    <!-- 连续的内容滚动区 -->
    <div class="sub-tab-content">
      
      <!-- 1. 产品/服务搭配 -->
      <div class="suggest-block" id="suggest-product">
        <template v-if="goodsList.length">
          <div class="block-title">调理推荐</div>
          <div class="goods-list">
            <div
              v-for="(item, idx) in goodsList"
              :key="`${item.title || item.name}-${idx}`"
              class="promo-card"
              @click="onGoodsClick(item)"
            >
              <img
                class="promo-img"
                :src="item.image || item.img || item.picUrl || item.url || defaultAvatar"
                :alt="item.title || item.name || '商品图片'"
              />
              <div class="promo-body">
                <div class="promo-title van-multi-ellipsis--l3">{{ item.title || item.name }}</div>
                <div class="promo-footer">
                  <div class="promo-market-price">
                    市场价
                    <span>¥{{ formatPrice(item.marketPrice || item.market_price || 0) }}</span>
                  </div>
                  <div class="promo-price-row">
                    <div class="promo-sale-price">
                      <span class="price-symbol">¥</span>{{ formatPrice(item.salePrice || item.sale_price || item.price || 0) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <van-empty v-else image="search" description="暂时没有商品，敬请期待！" />
      </div>

      <!-- 2. 中医调理建议 -->
      <div class="suggest-block" id="suggest-tcm" v-if="suggestions.tCMRegulationSuggestions">
        <div class="block-title">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/中医调理建议.png" alt="中医调理建议" class="title-icon" /> 中医调理建议
        </div>
        <div class="block-card">
          {{ suggestions.tCMRegulationSuggestions }}
        </div>
      </div>

      <!-- 3. 经络保健建议 -->
      <div class="suggest-block" id="suggest-meridian" v-if="suggestions.meridianHealthCare && suggestions.meridianHealthCare.list && suggestions.meridianHealthCare.list.length">
        <div class="block-title">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/经络保健建议.png" alt="经络保健建议" class="title-icon" /> 经络保健建议
        </div>
        <div class="block-card">
          <div class="card-subtitle">经络建议：</div>
          <div class="card-text" v-if="suggestions.meridianHealthCare.suggestions">
            {{ suggestions.meridianHealthCare.suggestions }}
          </div>
          
          <div class="card-subtitle" style="margin-top: 16px;">经络推荐：</div>
          <div class="recommend-grid">
            <div class="recommend-item" v-for="(item, idx) in suggestions.meridianHealthCare.list" :key="idx">
              <img :src="item.img || defaultAvatar" class="recommend-img" />
              <div class="recommend-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 4. 穴位保健建议 -->
      <div class="suggest-block" id="suggest-acupoint" v-if="suggestions.acupointHealthCare && suggestions.acupointHealthCare.list && suggestions.acupointHealthCare.list.length">
        <div class="block-title">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/穴位保健.png" alt="穴位保健建议" class="title-icon" /> 穴位保健建议
        </div>
        <div class="block-card">
          <div class="card-subtitle">穴位建议：</div>
          <div class="card-text" v-if="suggestions.acupointHealthCare.suggestions">
            {{ suggestions.acupointHealthCare.suggestions }}
          </div>
          <div class="card-note" v-if="suggestions.acupointHealthCare.method">
            保健方式：{{ suggestions.acupointHealthCare.method }}
          </div>
          
          <div class="card-subtitle" style="margin-top: 16px;">穴位推荐：</div>
          <div class="recommend-grid">
            <div class="recommend-item" v-for="(item, idx) in suggestions.acupointHealthCare.list" :key="idx">
              <img :src="item.img || defaultAvatar" class="recommend-img" />
              <div class="recommend-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 5. 饮食调养建议 -->
      <div class="suggest-block" id="suggest-diet" v-if="suggestions.foodsSuggestions">
        <div class="block-title">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/饮食调养建议.png" alt="饮食调养建议" class="title-icon" /> 饮食调养建议
        </div>
        <div class="block-card">
          <div class="diet-row" v-if="suggestions.foodsSuggestions.recommend">
            <span class="diet-label">【宜】</span> {{ suggestions.foodsSuggestions.recommend }}
          </div>
          <div class="diet-row" v-if="suggestions.foodsSuggestions.avoid">
            <span class="diet-label" style="color: #FF5001;">【忌】</span> {{ suggestions.foodsSuggestions.avoid }}
          </div>
          <div class="diet-row" v-if="suggestions.foodsSuggestions.suggestions" style="margin-top: 8px;">
            <span class="diet-label">【建议】</span> {{ suggestions.foodsSuggestions.suggestions }}
          </div>
        </div>
      </div>

      <!-- 6. 推荐饮食列表 -->
      <div class="suggest-block" id="suggest-food" v-if="suggestions.recommendFoods && suggestions.recommendFoods.list && suggestions.recommendFoods.list.length">
        <div class="block-title">
          推荐饮食
        </div>
        <div class="block-card">
          <div class="food-item" v-for="(item, idx) in suggestions.recommendFoods.list" :key="idx">
            <div class="food-name">{{ item.name }}</div>
            <div class="food-detail"><span class="food-label">食材：</span>{{ item.ingredients }}</div>
            <div class="food-detail"><span class="food-label">烹饪方法：</span>{{ item.cookingMethods }}</div>
            <div class="food-detail"><span class="food-label">功效：</span>{{ item.efficacy }}</div>
          </div>
        </div>
      </div>

      <!-- 7. 运动保健 -->
      <div class="suggest-block" id="suggest-exercise" v-if="suggestions.exerciseHealthCareSuggestions">
        <div class="block-title">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/运动保健.png" alt="运动保健" class="title-icon" /> 运动保健
        </div>
        <div class="block-card">
          <div class="card-subtitle">运动保健建议</div>
          {{ suggestions.exerciseHealthCareSuggestions }}
        </div>
      </div>

      <!-- 8. 情致调养 -->
      <div class="suggest-block" id="suggest-emotion" v-if="suggestions.emotionalNourishmentSuggestions">
        <div class="block-title">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/情致调养.png" alt="情致调养" class="title-icon" /> 情致调养
        </div>
        <div class="block-card">
          {{ suggestions.emotionalNourishmentSuggestions }}
        </div>
      </div>

      <!-- 9. 起居调养 -->
      <div class="suggest-block" id="suggest-living" v-if="suggestions.dailyLivingNourishmentSuggestions">
        <div class="block-title">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/起居调养.png" alt="起居调养" class="title-icon" /> 起居调养
        </div>
        <div class="block-card">
          {{ suggestions.dailyLivingNourishmentSuggestions }}
        </div>
      </div>

    </div>

    <!-- 底部声明与时间 -->
    <div class="bottom-statement">
      重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论。如已有身体不适，请及时咨询医生。
      <div class="time-text" v-if="reportData.createAt">生成时间：{{ reportData.createAt }}</div>
    </div>
  </div>
</template>

<script>
import { Empty, Toast } from 'vant';

export default {
  name: 'ConditioningSuggestions',
  components: {
    [Empty.name]: Empty,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeSubTab: 'product',
      isClickScrolling: false,
      clickScrollTimer: null,
      scrollEndTimer: null,
      pendingActiveTabId: '',
      defaultAvatar: 'https://img01.yzcdn.cn/vant/cat.jpeg'
    };
  },
  computed: {
    suggestions() {
      return this.reportData?.tongueReport?.suggestions || null;
    },
    goodsList() {
      const list = this.reportData?.goodsList
        || this.reportData?.tongueReport?.goodsList
        || this.suggestions?.goodsList
        || [];

      if (!Array.isArray(list)) return [];

      return [...list].sort((a, b) => {
        const sortA = Number(a?.sort || 0);
        const sortB = Number(b?.sort || 0);
        return sortA - sortB;
      });
    },
    suggestTabs() {
      if (!this.suggestions) return [];
      const s = this.suggestions;
      const tabs = [];
      tabs.push({ id: 'product', title: '产品/服务搭配' });
      if (s.tCMRegulationSuggestions) tabs.push({ id: 'tcm', title: '中医调理' });
      if (s.meridianHealthCare?.list?.length) tabs.push({ id: 'meridian', title: '经络保健' });
      if (s.acupointHealthCare?.list?.length) tabs.push({ id: 'acupoint', title: '穴位保健' });
      if (s.foodsSuggestions) tabs.push({ id: 'diet', title: '饮食调养' });
      if (s.recommendFoods?.list?.length) tabs.push({ id: 'food', title: '推荐饮食' });
      if (s.exerciseHealthCareSuggestions) tabs.push({ id: 'exercise', title: '运动保健' });
      if (s.emotionalNourishmentSuggestions) tabs.push({ id: 'emotion', title: '情致调养' });
      if (s.dailyLivingNourishmentSuggestions) tabs.push({ id: 'living', title: '起居调养' });
      return tabs;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, true); // 使用捕获模式，确保能监听到内部滚动
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll, true);
    if (this.clickScrollTimer) {
      clearTimeout(this.clickScrollTimer);
      this.clickScrollTimer = null;
    }
    if (this.scrollEndTimer) {
      clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = null;
    }
  },
  methods: {
    formatPrice(value) {
      const amount = Number(value || 0) / 100;
      return Number.isInteger(amount) ? amount : amount.toFixed(2);
    },
    getStickyOffset() {
      // 顶部固定区域 = 导航栏 46px + 一级 tabs 44px + 二级 tabs 自身高度
      let suggestTabsHeight = 56;
      if (this.$refs.suggestTabsContainer) {
        suggestTabsHeight = this.$refs.suggestTabsContainer.offsetHeight;
      }
      return 46 + 44 + suggestTabsHeight;
    },
    getSectionTitleOffset(id) {
      const sectionEl = document.getElementById(`suggest-${id}`);
      if (!sectionEl) return 0;

      const titleEl = sectionEl.querySelector('.block-title');
      if (!titleEl) return 0;

      const titleStyle = window.getComputedStyle(titleEl);
      const marginBottom = Number.parseFloat(titleStyle.marginBottom || '0') || 0;
      return titleEl.offsetHeight + marginBottom;
    },
    getSectionScrollOffset(id) {
      const titleOffset = this.getSectionTitleOffset(id);
      return this.getStickyOffset() + Math.max(titleOffset / 3, 0) + 6;
    },
    getCurrentSectionId(preferredId = '') {
      const tabs = this.suggestTabs;
      if (!tabs.length) return '';

      const metrics = tabs.map((tab) => {
        const el = document.getElementById(`suggest-${tab.id}`);
        if (!el) {
          return null;
        }

        const triggerLine = this.getSectionScrollOffset(tab.id);
        const rectTop = el.getBoundingClientRect().top;
        return {
          id: tab.id,
          rectTop,
          triggerLine,
          distance: Math.abs(rectTop - triggerLine)
        };
      }).filter(Boolean);

      if (!metrics.length) return tabs[0].id;

      const anchorLine = this.getStickyOffset() + 8;

      if (preferredId) {
        const preferredMetric = metrics.find(item => item.id === preferredId);
        if (preferredMetric && preferredMetric.rectTop <= anchorLine + 28) {
          return preferredId;
        }
      }

      const currentVisible = [...metrics].reverse().find(item => item.rectTop <= anchorLine);

      return currentVisible?.id || tabs[0].id;
    },
    scrollToTab(id) {
      this.activeSubTab = id;
      this.pendingActiveTabId = id;
      this.isClickScrolling = true;
      if (this.clickScrollTimer) {
        clearTimeout(this.clickScrollTimer);
      }
      if (this.scrollEndTimer) {
        clearTimeout(this.scrollEndTimer);
        this.scrollEndTimer = null;
      }
      const el = document.getElementById(`suggest-${id}`);
      if (el) {
        // 留出一定的顶部偏移量，防止被导航条遮挡
        const offset = this.getSectionScrollOffset(id);
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        this.centerTab(id, false);
        this.clickScrollTimer = setTimeout(() => {
          this.clickScrollTimer = null;
        }, 1200);
      }
    },
    updateActiveTabByScroll() {
      const currentId = this.getCurrentSectionId(this.pendingActiveTabId);
      this.pendingActiveTabId = '';

      if (this.activeSubTab !== currentId) {
        this.activeSubTab = currentId;
        this.centerTab(currentId, false);
      }
    },
    onScroll() {
      if (this.scrollEndTimer) {
        clearTimeout(this.scrollEndTimer);
      }

      if (this.isClickScrolling) {
        this.scrollEndTimer = setTimeout(() => {
          this.isClickScrolling = false;
          this.scrollEndTimer = null;
          this.updateActiveTabByScroll();
        }, 160);
        return;
      }

      this.scrollEndTimer = setTimeout(() => {
        this.scrollEndTimer = null;
        this.updateActiveTabByScroll();
      }, 160);
    },
    centerTab(id, smooth = false) {
      this.$nextTick(() => {
        const tabEl = this.$refs[`tab-${id}`]?.[0];
        const container = this.$refs.suggestTabsContainer;
        if (tabEl && container) {
          const tabLeft = tabEl.offsetLeft;
          const tabRight = tabLeft + tabEl.offsetWidth;
          const visibleLeft = container.scrollLeft;
          const visibleRight = visibleLeft + container.offsetWidth;

          if (tabLeft >= visibleLeft && tabRight <= visibleRight) {
            return;
          }

          const targetLeft = tabLeft - (container.offsetWidth / 2) + (tabEl.offsetWidth / 2);
          const maxScrollLeft = Math.max(0, container.scrollWidth - container.offsetWidth);
          const nextScrollLeft = Math.min(Math.max(targetLeft, 0), maxScrollLeft);

          container.scrollTo({ left: nextScrollLeft, behavior: smooth ? 'smooth' : 'auto' });
        }
      });
    },
    onGoodsClick(item) {
      const actionUrl = item.actionUrl || item.action_url || '';
      if (item.wxAppId) {
        if (window.wx && window.wx.miniProgram) {
          window.wx.miniProgram.navigateTo({
            url: actionUrl
          });
        } else {
          Toast('请在微信小程序中打开');
        }
      } else if (actionUrl.startsWith('http')) {
        window.location.href = actionUrl;
      } else if (actionUrl) {
        this.$router.push(actionUrl);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 复用面诊报告调理建议的样式 */
.suggest-bg {
  background: #F7F8FA;
  min-height: 100vh;
  padding-bottom: 60vh; /* 增加底部留白，确保最后一项内容能滚到顶部 */
}

.page-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px 8px;
}

.page-header-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
  object-fit: contain;
}

.page-header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* 顶部三个按钮 */
.suggest-tabs {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  gap: 12px;
  overflow-x: auto;
  white-space: nowrap;
  position: sticky;
  top: 90px; /* 固定在导航栏 + 一级 tabs 下方，避免顶到一级 tabs */
  z-index: 99;
  scrollbar-width: none; 
  -ms-overflow-style: none;
}
.suggest-tabs::-webkit-scrollbar {
  display: none;
}
.suggest-tab-item {
  flex: none;
  text-align: center;
  font-size: 14px;
  color: #333;
  border: 1px solid #333;
  background: transparent;
  border-radius: 20px;
  padding: 6px 16px;
  transition: all 0.3s;
}
.suggest-tab-item.active {
  background: #44C2C4;
  color: #fff;
  border-color: #44C2C4;
}

.sub-tab-content {
  padding: 16px;
}

/* 调理建议每个区块 */
.suggest-block {
  margin-bottom: 20px;
  scroll-margin-top: 102px;
}
.block-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  justify-content: center;
}
.title-icon {
  width: 40px;
  height: 40px;
  margin-right: 1px;
  object-fit: contain;
}
.block-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  border: 1px solid #eaeaea;
}
.goods-list {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.promo-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  gap: 10px;
  cursor: pointer;
}
.promo-img {
  width: 150px;
  height: 150px;
  flex-shrink: 0;
  border-radius: 6px;
  object-fit: cover;
  margin-right: 0;
}
.promo-body {
  flex: 1;
  position: relative;
  min-width: 0;
  padding: 4px 10px 6px 0;
}
.promo-title {
  color: #333;
  font-size: 15px;
  line-height: 1.5;
}
.promo-footer {
  position: absolute;
  left: 0;
  right: 10px;
  bottom: 6px;
}
.promo-market-price {
  color: #939293;
  margin-bottom: 8px;
  font-size: 12px;
}
.promo-market-price span {
  text-decoration: line-through;
}
.promo-price-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.promo-sale-price {
  color: #FF000B;
  font-weight: bold;
  font-size: 20px;
}
.price-symbol {
  font-size: 12px;
}
.card-subtitle {
  font-weight: bold;
  margin-bottom: 8px;
}
.card-text {
  margin-bottom: 8px;
}
.card-note {
  font-size: 12px;
  color: #999;
  margin-top: 16px;
}

/* 网格与图片 (经络/穴位) */
.recommend-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.recommend-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.recommend-img {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid #f0f0f0;
}
.recommend-name {
  font-size: 13px;
  color: #333;
  text-align: center;
}

/* 饮食调养 */
.diet-row {
  margin-bottom: 4px;
  text-align: justify;
}
.diet-label {
  font-weight: bold;
  color: #44C2C4;
}

/* 推荐饮食列表 */
.food-item {
  padding: 12px 0;
  border-bottom: 1px dashed #e5e5e5;
}
.food-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.food-name {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}
.food-detail {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
  text-align: justify;
}
.food-label {
  color: #333;
  font-weight: bold;
}

/* 底部声明 */
.bottom-statement {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  text-align: justify;
  margin: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e5e5e5;
}
.time-text {
  margin-top: 4px;
}
</style>